import React, { useEffect, useState, useContext, useRef } from "react";
import { get_product_processing, get_undistributed_products } from "../../../../Utility/Api";
import { useNavigate } from "react-router-dom";
import { NaviGate, shop_id } from "../../../../Utility/function";
import { WarehouseContext } from "../../../../Utility/UserContext";
import "./../table.css";

const FinishedProductReport = () => {
    const navigate = useNavigate();
    const { showLoader, hideLoader, shopItem } = useContext(WarehouseContext);
    const [processes, setProcesses] = useState([]);
    const [undistributedBatches, setUndistributedBatches] = useState({});
    const [searchText, setSearchText] = useState("");
    const [selectedStatus, setSelectedStatus] = useState("");
    const [companyInfo, setCompanyInfo] = useState({
        name: "ZTR Masala",
        address: "Business Address",
        phone: "",
        email: ""
    });

    useEffect(() => {
        if (shopItem) {
            setCompanyInfo({
                name: shopItem?.title || "ZTR Masala",
                address: shopItem?.Address || "Business Address",
                phone: shopItem?.phone1 || "",
                email: shopItem?.email || ""
            });
        }
    }, [shopItem]);

    useEffect(() => {
        fetchData();
    }, []);

    const fetchData = async () => {
        try {
            showLoader();
            const currentShopId = shopItem?.shop_id || shop_id || "0";
            const params = {
                shop_id: currentShopId
            };
            const response = await get_product_processing(params);

            const undistResponse = await get_undistributed_products({
                shop_id: currentShopId,
                page_size: 100000
            });

            const undistMap = {};
            if (undistResponse.data && undistResponse.data.data) {
                undistResponse.data.data.forEach(item => {
                    if (item.batch_no) {
                        undistMap[String(item.batch_no)] = parseFloat(item.remaining || 0);
                    }
                });
            }
            setUndistributedBatches(undistMap);

            if (response.data && response.data.data) {
                const processedItems = [];
                response.data.data.forEach(item => {
                    const statusNum = parseInt(item.status);
                    
                    if (statusNum === 3 || statusNum === 4) {
                        const totalQty = parseFloat(item.manufactured_qty || item.desired_qty || 0);
                        const remainingBulk = undistMap[String(item.batch_no)] !== undefined
                            ? undistMap[String(item.batch_no)]
                            : (statusNum === 3 ? parseFloat(item.avl_qty || 0) : 0);
                        
                        const distributedQty = Math.max(0, totalQty - remainingBulk);
                        
                        if (distributedQty > 0) {
                            processedItems.push({
                                ...item,
                                id: `${item.id}_dist`,
                                status: "4", // Distributed
                                manufactured_qty: distributedQty,
                                desired_qty: distributedQty,
                                avl_qty: distributedQty,
                                isLoose: false
                            });
                        }
                        
                        if (remainingBulk > 0) {
                            processedItems.push({
                                ...item,
                                id: `${item.id}_undist`,
                                status: "3", // Completed (Loose Product)
                                manufactured_qty: remainingBulk,
                                desired_qty: remainingBulk,
                                avl_qty: remainingBulk,
                                isLoose: true
                            });
                        }
                        
                        if (distributedQty <= 0 && remainingBulk <= 0) {
                            processedItems.push({
                                ...item,
                                isLoose: statusNum === 3
                            });
                        }
                    }
                });
                setProcesses(processedItems);
            }
            hideLoader();
        } catch (error) {
            hideLoader();
            console.error("Error fetching finished products data:", error);
        }
    };

    const getStatusLabel = (status) => {
        const num = parseInt(status);
        if (num === 0) return "Pending";
        if (num === 1) return "In Progress";
        if (num === 2) return "Manufacturing";
        if (num === 3) return "Completed";
        if (num === 4) return "Distributed";
        return status;
    };

    const getStatusClass = (status) => {
        const num = parseInt(status);
        if (num === 0) return "text-warning fw-bold";
        if (num === 1) return "text-info fw-bold";
        if (num === 2) return "text-primary fw-bold";
        if (num === 3) return "text-success fw-bold";
        if (num === 4) return "text-success fw-bold";
        return "";
    };

    const applyFilters = () => {
        let filtered = [...processes];

        // Status filter
        if (selectedStatus) {
            filtered = filtered.filter(item => String(item.status) === String(selectedStatus));
        }

        // Search text
        if (searchText) {
            const search = searchText.toLowerCase();
            filtered = filtered.filter(item =>
                (item.product_title && item.product_title.toLowerCase().includes(search)) ||
                (item.batch_no && item.batch_no.toLowerCase().includes(search))
            );
        }

        return filtered;
    };

    const filteredData = applyFilters();

    const getGroupedData = (data) => {
        const groups = {};
        data.forEach(item => {
            const key = `${item.p_id}_${item.status}`;
            if (!groups[key]) {
                groups[key] = {
                    ...item,
                    batch_numbers: [item.batch_no].filter(Boolean),
                    qty: parseFloat(item.manufactured_qty || item.desired_qty || 0),
                    avl_qty: parseFloat(item.avl_qty || 0),
                    latest_date: item.create_date
                };
            } else {
                groups[key].qty += parseFloat(item.manufactured_qty || item.desired_qty || 0);
                groups[key].avl_qty += parseFloat(item.avl_qty || 0);
                if (item.batch_no && !groups[key].batch_numbers.includes(item.batch_no)) {
                    groups[key].batch_numbers.push(item.batch_no);
                }
                if (item.create_date && (!groups[key].latest_date || item.create_date > groups[key].latest_date)) {
                    groups[key].latest_date = item.create_date;
                }
            }
        });

        return Object.values(groups).map(g => {
            const isLoose = parseInt(g.status) === 3;
            return {
                ...g,
                batch_no: g.batch_numbers.join(", "),
                create_date: g.latest_date,
                manufactured_qty: g.qty,
                desired_qty: g.qty,
                avl_qty: g.avl_qty,
                isLoose: isLoose
            };
        });
    };

    const groupedData = getGroupedData(filteredData);

    const handlePrint = () => {
        const printWindow = window.open('', '_blank');
        const printContent = document.getElementById('printable-finished-product-report').innerHTML;

        printWindow.document.write(`
            <!DOCTYPE html>
            <html>
            <head>
                <title>Finished Product Report</title>
                <style>
                    @media print {
                        @page {
                            size: A4 portrait;
                            margin: 0.5in;
                        }
                        body {
                            font-family: Arial, sans-serif;
                            font-size: 12pt;
                            color: #000;
                            background: #fff;
                        }
                        .print-container {
                            width: 100%;
                            max-width: 21cm;
                            margin: 0 auto;
                        }
                        .print-header {
                            text-align: center;
                            margin-bottom: 20px;
                            border-bottom: 2px solid #000;
                            padding-bottom: 15px;
                        }
                        .print-header h1 {
                            font-size: 20pt;
                            margin: 0;
                            color: #000;
                        }
                        .print-header p {
                            margin: 5px 0;
                            font-size: 11pt;
                        }
                        .report-info {
                            margin: 15px 0;
                            padding: 10px;
                            background-color: #f8f9fa;
                            border-radius: 5px;
                            display: flex;
                            justify-content: space-between;
                        }
                        .report-table {
                            width: 100%;
                            border-collapse: collapse;
                            margin: 15px 0;
                            font-size: 10pt;
                        }
                        .report-table th, .report-table td {
                            border: 1px solid #ddd;
                            padding: 8px;
                            text-align: left;
                        }
                        .report-table th {
                            background-color: #f2f2f2;
                            font-weight: bold;
                        }
                        .report-totals {
                            margin-top: 20px;
                            padding: 15px;
                            border: 1px solid #ddd;
                            border-radius: 5px;
                            background-color: #f9f9f9;
                        }
                        .total-row {
                            display: flex;
                            justify-content: space-between;
                            margin: 5px 0;
                        }
                        .total-amount {
                            font-weight: bold;
                            font-size: 13pt;
                        }
                        .footer {
                            margin-top: 30px;
                            text-align: center;
                            font-size: 10pt;
                            color: #6c757d;
                        }
                    }
                </style>
            </head>
            <body>
                ${printContent}
                <script>
                    window.onload = function() {
                        window.print();
                        setTimeout(function() {
                            window.close();
                        }, 100);
                    };
                </script>
            </body>
            </html>
        `);
        printWindow.document.close();
    };

    const totalItems = groupedData.length;

    return (
        <div className="page-content py-1">
            <NaviGate />
            <div className="card p-3 mx-2 overflow-y-scroll" style={{ minHeight: "90vh" }}>
                <div className="d-flex mb-4 border-bottom justify-content-between align-items-center flex-wrap pb-3" style={{ width: "100%" }}>
                    <h5 className="text-start w-auto fw-bold mb-0 text-uppercase">
                        Finished Product Report
                    </h5>
                    <div className="d-flex gap-2 align-items-center flex-wrap ms-auto">

                        {/* Search Bar */}
                        <div style={{ width: "220px" }}>
                            <div className="form-floating">
                                <input
                                    className="form-control"
                                    value={searchText}
                                    onChange={(e) => setSearchText(e.target.value)}
                                    placeholder="Search"
                                />
                                <label>Search Product</label>
                            </div>
                        </div>

                        {/* Filter by Status */}
                        <div style={{ width: "200px" }}>
                            <div className="form-floating">
                                <select
                                    className="form-select"
                                    value={selectedStatus}
                                    onChange={(e) => setSelectedStatus(e.target.value)}
                                >
                                    <option value="">All Statuses</option>
                                    <option value="3">Completed</option>
                                    <option value="4">Distributed</option>
                                </select>
                                <label>Process Status</label>
                            </div>
                        </div>

                        {/* Print Button */}
                        <button
                            type="button"
                            className="btn btn-dark p-3"
                            onClick={handlePrint}
                            style={{ height: "58px" }}
                        >
                            <i className="bi bi-printer me-1"></i> Print
                        </button>
                    </div>
                </div>

                <div className="d-flex justify-content-between mb-3 px-2">
                    <div>
                        <strong>Total Records:</strong> {totalItems}
                    </div>
                </div>

                {/* Table View */}
                <div className="table-responsive text-center my-2 w-100 position-relative">
                    <table className="table table-sm table-bordered table-hover">
                        <thead className="table-dark">
                            <tr>
                                <th>S.No</th>
                                <th>Product Name</th>
                                <th>Processed Quantity</th>
                                <th>Status</th>
                                <th>Avl Qty</th>
                                <th>Created Date</th>
                            </tr>
                        </thead>
                        <tbody>
                            {groupedData.length > 0 ? (
                                groupedData.map((item, index) => {
                                    const qty = parseFloat(item.manufactured_qty || item.desired_qty || 0);
                                    const looseProduct = parseFloat(item.avl_qty || 0);

                                    return (
                                        <tr key={item.id || index}>
                                            <td>{index + 1}</td>
                                            <td className="fw-semibold text-start px-3">
                                                {item.product_title || "-"}
                                                {item.isLoose && (
                                                    <span className="text-muted fw-normal ms-1" style={{ fontSize: "12px" }}>
                                                        ({(item.product_title || "").toLowerCase().includes("powder") ? "loose powder" : "loose product"})
                                                    </span>
                                                )}
                                            </td>
                                            <td>{qty.toFixed(2)} {item.unit || "kg"}</td>
                                            <td className={getStatusClass(item.status)}>{getStatusLabel(item.status)}</td>
                                            <td className="text-end px-3 fw-bold text-primary">
                                                {parseFloat(item.status) >= 3 ? (
                                                    `${looseProduct.toFixed(2)} ${item.unit || "kg"}`
                                                ) : (
                                                    <span className="text-muted fw-normal">-</span>
                                                )}
                                            </td>
                                            <td>{item.create_date?.split('T')[0] || "-"}</td>
                                        </tr>
                                    );
                                })
                            ) : (
                                <tr>
                                    <td colSpan="6" className="text-center py-4 text-muted">
                                        No finished products found.
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>

                {/* Printable Report (Hidden in normal screen view) */}
                <div id="printable-finished-product-report" style={{ display: 'none' }}>
                    <div className="print-container">
                        <div className="print-header">
                            <h1>{companyInfo.name}</h1>
                            <p>{companyInfo.address}</p>
                            <p>Phone: {companyInfo.phone} | Email: {companyInfo.email}</p>
                            <h2 style={{ marginTop: '20px', textTransform: 'uppercase' }}>Finished Product Stock Report</h2>
                        </div>

                        <div className="report-info">
                            <div>
                                <strong>Generated On:</strong> {new Date().toLocaleDateString()} at {new Date().toLocaleTimeString()}
                            </div>
                            <div>
                                <strong>Total Records:</strong> {totalItems}
                            </div>
                        </div>

                        <table className="report-table">
                            <thead>
                                <tr>
                                    <th>S.No</th>
                                    <th>Product Name</th>
                                    <th>Processed Quantity</th>
                                    <th>Status</th>
                                    <th>Available Qty</th>
                                    <th>Created Date</th>
                                </tr>
                            </thead>
                            <tbody>
                                {groupedData.length > 0 ? (
                                    groupedData.map((item, index) => {
                                        const qty = parseFloat(item.manufactured_qty || item.desired_qty || 0);
                                        const looseProduct = parseFloat(item.avl_qty || 0);

                                        return (
                                            <tr key={item.id || index}>
                                                <td>{index + 1}</td>
                                                <td style={{ fontWeight: 'bold' }}>
                                                    {item.product_title || "-"}
                                                    {item.isLoose && (
                                                        <span style={{ fontWeight: 'normal', color: '#6c757d', marginLeft: '5px', fontSize: '11px' }}>
                                                            ({(item.product_title || "").toLowerCase().includes("powder") ? "loose powder" : "loose product"})
                                                        </span>
                                                    )}
                                                </td>
                                                <td>{qty.toFixed(2)} {item.unit || "kg"}</td>
                                                <td>{getStatusLabel(item.status)}</td>
                                                <td style={{ fontWeight: 'bold', color: '#004085' }}>
                                                    {parseFloat(item.status) >= 3 ? (
                                                        `${looseProduct.toFixed(2)} ${item.unit || "kg"}`
                                                    ) : (
                                                        "-"
                                                    )}
                                                </td>
                                                <td>{item.create_date?.split('T')[0] || "-"}</td>
                                            </tr>
                                        );
                                    })
                                ) : (
                                    <tr>
                                        <td colSpan="6" style={{ textAlign: 'center' }}>
                                            No finished products found.
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>

                        <div className="report-totals">
                            <h3>Report Summary</h3>
                            <div className="total-row">
                                <span>Total Process Records:</span>
                                <span className="total-amount">{totalItems}</span>
                            </div>
                        </div>

                        <div className="footer">
                            <p>ZTR Masala Inventory Management System</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default FinishedProductReport;
